<!-- align-items-center leads to messed up content layout -->
<div class="container-fluid vh-100 d-flex justify-content-center">
  <div>
    @switch (navigationInfo.section + '-' + navigationInfo.title) {
      <!-- Introduction -->
      @case ('introduction-welcome') {
        <app-instruction-container-bg-half
          [instruction]="'welcome'"
          [label]="studyStartContinueButtonLabel"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-half>
      }
      @case ('screening-welcome') {
        <app-instruction-container-bg-half
          [instruction]="'screening'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-half>
      }
      @case ('introduction-consent') {
        <app-instruction-container-bg-mono
          [showConsent]="true"
          [label]="continueButtonLabel"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      <!-- Persona -->
      @case ('persona-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'persona-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('persona-baseline-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'persona-baseline-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('persona-baseline-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('persona-how-to') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'persona-how-to'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('persona-instruction-speed') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'persona-instruction-speed'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('persona-practice-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'persona-practice-intro'"
          [section]="navigationInfo.section"
          [showContinue]="false"
          [isPracticeIntro]="true"
        ></app-instruction-container-bg-mono>
      }
      @case ('persona-practice-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('persona-IAT-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('persona-IAT-question') {
        <app-instruction-container
          [instruction]="'persona-IAT-question'"
          [time]="IATQuestionDisplayLength"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('persona-countdown') {
        <app-instruction-container
          [showCountdown]="true"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('persona-IAT-finger-placement') {
        <app-instruction-container
          [section]="navigationInfo.section"
          [instruction]="'persona-IAT-finger-placement'"
          [time]="fingerPlacementDisplayLength"
        ></app-instruction-container>
      }
      @case ('persona-IAT-intro') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'persona-IAT-intro'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      @case ('persona-section-end') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'persona-section-end'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      <!-- Brand -->
      @case ('brand-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'brand-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('brand-baseline-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'brand-baseline-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('brand-baseline-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('brand-how-to') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'brand-how-to'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('brand-instruction-speed') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'brand-instruction-speed'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('brand-practice-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'brand-practice-intro'"
          [section]="navigationInfo.section"
          [showContinue]="false"
          [isPracticeIntro]="true"
        ></app-instruction-container-bg-mono>
      }
      @case ('brand-practice-image') {
        <app-image-full
          [instruction]="'brand-practice-image'"
          [section]="navigationInfo.section"
          [label]="continueButtonLabel"
        ></app-image-full>
      }
      @case ('brand-IAT-question') {
        <app-instruction-container
          [instruction]="'brand-IAT-question'"
          [time]="IATQuestionDisplayLength"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('brand-countdown') {
        <app-instruction-container [showCountdown]="true"></app-instruction-container>
      }
      @case ('brand-IAT-finger-placement') {
        <app-instruction-container
          [section]="navigationInfo.section"
          [instruction]="'brand-IAT-finger-placement'"
          [time]="fingerPlacementDisplayLength"
        ></app-instruction-container>
      }
      @case ('brand-practice-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('brand-IAT-intro') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'brand-IAT-intro'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      @case ('brand-IAT-image') {
        <app-image-full
          [instruction]="'brand-IAT-image'"
          [section]="navigationInfo.section"
          [label]="continueButtonLabel"
          [isPractice]="false"
        ></app-image-full>
      }
      @case ('brand-IAT-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('brand-section-end') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'brand-section-end'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      <!-- Modular -->
      @case ('modular-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'modular-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('modular-baseline-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'modular-baseline-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('modular-baseline-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('modular-how-to') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'modular-how-to'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('modular-instruction-speed') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'modular-instruction-speed'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('modular-practice-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'modular-practice-intro'"
          [section]="navigationInfo.section"
          [showContinue]="false"
          [isPracticeIntro]="true"
        ></app-instruction-container-bg-mono>
      }
      @case ('modular-practice-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('modular-IAT-test') {
        <app-test-display
          [intermissionButtonLabel]="intermissionButtonLabel"
        ></app-test-display>
      }
      @case ('modular-IAT-question') {
        <app-instruction-container
          [instruction]="'modular-IAT-question'"
          [time]="IATQuestionDisplayLength"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('modular-countdown') {
        <app-instruction-container [showCountdown]="true"></app-instruction-container>
      }
      @case ('modular-IAT-finger-placement') {
        <app-instruction-container
          [section]="navigationInfo.section"
          [instruction]="'modular-IAT-finger-placement'"
          [time]="fingerPlacementDisplayLength"
        ></app-instruction-container>
      }
      @case ('modular-IAT-intro') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'modular-IAT-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('modular-section-end') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'modular-section-end'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      <!-- IAT -->
      @case ('IAT-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'IAT-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('IAT-how-to') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'IAT-how-to'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('IAT-IAT-test') {
        <app-iat-display></app-iat-display>
      }
      @case ('IAT-IAT-question') {
        <app-instruction-container
          [instruction]="'IAT-IAT-question'"
          [time]="IATQuestionDisplayLength"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('IAT-countdown') {
        <app-instruction-container
          [showCountdown]="true"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('IAT-IAT-finger-placement') {
        <app-instruction-container
          [section]="navigationInfo.section"
          [instruction]="'IAT-IAT-finger-placement'"
          [time]="fingerPlacementDisplayLength"
        ></app-instruction-container>
      }
      @case ('IAT-section-end') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'IAT-section-end'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      <!-- Conjoint -->
      @case ('conjoint-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'conjoint-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('conjoint-practice-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'conjoint-practice-intro'"
          [section]="navigationInfo.section"
          [showContinue]="true"
          [isPracticeIntro]="true"
        ></app-instruction-container-bg-mono>
      }
      @case ('conjoint-practice-test') {
        <app-conjoint-display></app-conjoint-display>
      }
      @case ('conjoint-IAT-intro') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'conjoint-IAT-intro'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      @case ('conjoint-IAT-test') {
        <app-conjoint-display></app-conjoint-display>
      }
      @case ('conjoint-IAT-question') {
        <app-instruction-container
          [instruction]="'conjoint-IAT-question'"
          [time]="IATQuestionDisplayLength"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('conjoint-countdown') {
        <app-instruction-container
          [showCountdown]="true"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('conjoint-IAT-finger-placement') {
        <app-instruction-container
          [section]="navigationInfo.section"
          [instruction]="'conjoint-IAT-finger-placement'"
          [time]="fingerPlacementDisplayLength"
        ></app-instruction-container>
      }
      @case ('conjoint-section-end') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'conjoint-section-end'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      <!-- priming -->
      @case ('priming-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'priming-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('priming-how-to') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'priming-how-to'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('priming-IAT-test') {
        <app-priming-display></app-priming-display>
      }
      @case ('priming-IAT-question') {
        <app-instruction-container
          [instruction]="'priming-IAT-question'"
          [time]="IATQuestionDisplayLength"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('priming-countdown') {
        <app-instruction-container
          [showCountdown]="true"
          [section]="navigationInfo.section"
        ></app-instruction-container>
      }
      @case ('priming-IAT-finger-placement') {
        <app-instruction-container
          [section]="navigationInfo.section"
          [instruction]="'priming-IAT-finger-placement'"
          [time]="fingerPlacementDisplayLength"
        ></app-instruction-container>
      }
      @case ('priming-section-end') {
        <app-instruction-container-bg-mono
          [showConsent]="false"
          [label]="continueButtonLabel"
          [instruction]="'priming-section-end'"
          [section]="navigationInfo.section"
          [bgColor]="BgColors.IMG"
        ></app-instruction-container-bg-mono>
      }
      <!-- Questionnaire -->
      @case ('questionnaire-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'questionnaire-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      <!-- Screening  -->
      @case ('screening-screening') {
        <app-screening></app-screening>
      }
      @case ('questionnaire-questionnaire') {
        <app-questionnaire></app-questionnaire>
      }
      @case ('questionnaire-section-end') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'questionnaire-section-end'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      <!-- Media -->
      @case ('pdf-intro') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [instruction]="'pdf-intro'"
          [section]="navigationInfo.section"
        ></app-instruction-container-bg-mono>
      }
      @case ('pdf-viewer') {
        <app-media-display [label]="mediaContinueButtonLabel"></app-media-display>
      }
      <!-- Final -->
      @case ('final-final') {
        <app-instruction-container-bg-mono
          [label]="continueButtonLabel"
          [showContinue]="false"
          [instruction]="'final-final'"
          [section]="navigationInfo.section"
          [isFinalPage]="true"
        ></app-instruction-container-bg-mono>
      }
      <!-- Overview pages -->
      @case ('introduction-overview') {
        <app-overview></app-overview>
      }
      @case ('persona-overview') {
        <app-overview></app-overview>
      }
      @case ('brand-overview') {
        <app-overview></app-overview>
      }
      @case ('modular-overview') {
        <app-overview></app-overview>
      }
      @case ('IAT-overview') {
        <app-overview></app-overview>
      }
      @case ('priming-overview') {
        <app-overview></app-overview>
      }
      @case ('conjoint-overview') {
        <app-overview></app-overview>
      }
      @case ('questionnaire-overview') {
        <app-overview></app-overview>
      }
    }
  </div>
</div>
